import React from 'react';
import { cn } from '../../utils';

export interface DataTableShellProps {
  children: React.ReactNode;
  className?: string;
  /** Remove border when placed inside a Card that already has a border */
  borderless?: boolean;
}

/**
 * Unified data table shell: rounded corners, border, card background, horizontal scroll.
 * Wrap `<table>` or the `Table` component from `./Table`.
 */
const DataTableShell: React.FC<DataTableShellProps> = ({ children, className, borderless }) => {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-lg bg-card',
        !borderless && 'border border-border shadow-sm',
        className,
      )}
    >
      <div className="relative w-full overflow-x-auto">{children}</div>
    </div>
  );
};

export default DataTableShell;
